<script>
import { numberPercentage, maritalStatus } from '@/helpers/constants';

export default {
	computed: {
		profileData() {
			return this.$store.getters.profileData;
		},
		netMonthlyIncome() {
			if (this.profileData) {
				let studentNMI = Math.floor(this.profileData.netMonthlyIncome);
				let studentSpouseNMI = Math.floor(
					this.profileData.spouseNetMonthlyIncome
				);
				return studentNMI + studentSpouseNMI;
			}
			return null;
		},
		isMarried() {
			return (
				this.profileData.cmsMaritalStatus.status.toLowerCase() ==
					this.$t('married') ||
				this.profileData.cmsMaritalStatus.status.toLowerCase() ===
					maritalStatus.MARRIED.toLowerCase()
			);
		},
		childrenCount() {
			return this.profileData.studentChildren.length;
		},
		adultsCount() {
			return this.isMarried ? 2 : 1;
		},
		lifeStageIsYA() {
			const YALifeStageDisplayOrder = 1;
			return this.checkIfLSDisplayOrderEquals(YALifeStageDisplayOrder);
		},
		lifeStageIsTeenager() {
			const teenLifeStageDisplayOrder = 0;
			return this.checkIfLSDisplayOrderEquals(teenLifeStageDisplayOrder);
		},
		educationIsFree() {
			if (this.profileData && this.profileData.cmsEducation) {
				return this.profileData.cmsEducation.tuition === null;
			}
			return null;
		},
		hasMortageLoan() {
			if (
				this.profileData &&
				this.profileData.isApprovedAndUsedForMortgageLoan
			) {
				return this.profileData.isApprovedAndUsedForMortgageLoan;
			}
			return null;
		},
		hasAutoLoan() {
			if (this.profileData && this.profileData.isApprovedAndUsedForAutoLoan) {
				return this.profileData.isApprovedAndUsedForAutoLoan;
			}
			return null;
		},
		hasAutoLoanDealership() {
			if (
				this.profileData &&
				this.profileData.isApprovedAndUsedForAutoLoanDealership
			) {
				return this.profileData.isApprovedAndUsedForAutoLoanDealership;
			}
			return null;
		},
		budgetedCategoriesValue() {
			return this.$store.getters.budgetedCategoriesValue;
		},
		percentageOfNmiToSavings() {
			return this.profileData.simulation.percentageOfNmiToSavings;
		}
	},
	methods: {
		checkIfLSDisplayOrderEquals(displayOrder) {
			if (this.profileData) {
				return this.profileData.cmsLifeStage.displayOrder === displayOrder;
			}
			return null;
		},
		checkForProfileData() {
			if (!this.profileData) {
				this.$store.dispatch('getProfileData');
			}
		},
		calculateGuideLine(percentage) {
			const result = Math.floor((percentage / 100) * this.netMonthlyIncome);
			return result;
		},
		getLeftToBudget(subtractValue) {
			// subtractValue - the value that should be subtracted before returing the value
			// used in category since we remove the selected budget from the "total amount"
			// This is needed because wihtout that subtaction
			// the calculcation will be:
			// ex: NMI - Savings - categoriesBudget(including current one) - selectedBudget(for current category)

			const savings = this.$store.getters.savingsTotalAmount;
			const debts = this.$store.getters.debtsTotalAmount;

			const categoriesRecalculation = subtractValue
				? this.budgetedCategoriesValue - subtractValue
				: this.budgetedCategoriesValue;

			return this.netMonthlyIncome - categoriesRecalculation - savings - debts;
		},
		calculatePercentageOfNmiToSavings(
			percentageOfNmi = numberPercentage.TWENTY
		) {
			const isPercentageOfNmiChanged =
				this.percentageOfNmiToSavings > numberPercentage.ZERO;

			if (isPercentageOfNmiChanged) {
				percentageOfNmi = this.percentageOfNmiToSavings;
			}

			return percentageOfNmi / numberPercentage.HUNDRED;
		}
	}
};
</script>
